import { IHeaderDTO } from '@/dtos';

export const exportToCSV = <T>(headerDto: IHeaderDTO[], data: T[]) => {
  const csvContent = generateCSV(headerDto, data);
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', 'data.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const generateCSV = <T>(headerDto: IHeaderDTO[], data: T[]): string => {
  const rows: string[] = [];
  const headers = headerDto.map((header) => header.title).join(',');
  rows.push(headers);

  data.forEach((item) => {
    const row = headerDto
      .map((header) => {
        const value = getValueByPath(item, header.key);
        return `"${String(value ?? '').replaceAll('"', '""')}"`;
      })
      .join(',');
    rows.push(row);
  });

  return rows.join('\n');
};
export function getValueByPath<T>(obj: T, path: string) {
  return path
    .replace(/\[(\d+)\]/g, '.$1') // Convert array indices to dot notation
    .split('.') // Split into keys
    .reduce((acc: unknown, key) => {
      if (acc && typeof acc === 'object') {
        return (acc as Record<string, unknown>)[key];
      }
      return undefined;
    }, obj);
}
